export function getStatusName(val) {
    switch(val) {
        case 'TicketCancelationRequested':
            return 'Awaiting Cancellation';
        case 'PendingVoid':
            return 'Awaiting Void'
        default: return getGeneralStatus(val);
    }
}

export function getGeneralStatus(status) {
    switch(status) {
        case "PendingVoid" :
        case "PendingChange" :
        case "PendingReissue" :
        case "Pending" :
            return "Request Pending"
        case "PendingRefund" :
            return "Awaiting Airline Refund"
        case "Approved" :
            return "Under Review"
        case "PendingPayment" :
            return "Awaiting Payment"
        case 'Paid':
            return 'Processing'
        case "Success" :
            return "Completed"
        case "Rejected" :
        case "Denied" :
            return "Rejected"
        case "Failed" :
            return "Failed"
        case "Closed" :
            return "Closed"
        default: return status
    }
}